import { Attachment, AttDownloadUrlResDto, ContactDto, CopyQuesRecord, InsertCopySectionRecord, InsertDeleteRecordsOptions, PerformContact, QuestionItem, SelectedPDNotes, SignatureInfo, VisitStatus } from '@models/types/perform-types/perform-visit.types';
import { AttUploadUrlResponse } from '@models/dto/perform-sync.dto';
import { AttachmentCloudUploadStatus } from '@models/enums/attachment-cloud-upload-status.enum';
import { SyncAction } from '@models/enums/db-query-action.enum';
import { parseDateString } from '@utils/date.utilities';
import { PerformSyncState } from '@models/enums/perform-sync-state.enum';
import { AttachmentObjType, AttachmentType, SqlObjType } from '@models/enums/sql-ref-obj-type.enum';
import { PerformAuditAttachmentLocation } from '@models/enums/perform-attachment-location.enum';
import { SqLiteQueryWithParams } from '@models/types/sqlite.type';
export const FETCH_VISITS: string = 'select * from visits';
export function splInstructions(auditNo: string): SqLiteQueryWithParams {
    let query: SqLiteQueryWithParams = {
        query: `select spl_instructions from audits WHERE audit_no = ?`,
        params: [auditNo]
    }
    return query;
}

export function fetchAuditList(visit_no: string): SqLiteQueryWithParams {
    return {
        query: `SELECT oa.*,
    oap.ATTEMPTED,
    oap.ATTEMPTED_REASON,
    oap.form_completed,  (oa.DURATION || ' '  || oa.DURATION_UNIT) AS DURATION_COMBINED,
    oap.STATUS, oatm.audit_type
    FROM audits oa,
    audit_perform oap,
    audit_templates t,
    visits oav,
    accounts cus,
    audit_type_master oatm
    WHERE     oa.AUDIT_NO = oap.AUDIT_NO
    AND oav.VISIT_NO = oa.VISIT_NO
    AND oap.template_seq = t.SEQ
    AND oa.facility_seq = cus.seq
    AND oatm.seq = oa.AUDIT_TYPE_seq
    AND oa.visit_no = ?`,
        params: [visit_no]
    }

}

/**
 * Get audit details
 * @param visitNo
 * @param auditNo
 * @returns
 */
export function fetchAuditDetailsQuery(visitNo: string, auditNo: string): SqLiteQueryWithParams {
    return {
        query: `SELECT DISTINCT AUD.AUDIT_NO,AUD.VISIT_NO, AUD.CATEGORY AS audit_category, AUD.SPL_INSTRUCTIONS, EMP.EMP_NAME AS auditor,
MGR.EMP_NAME AS account_manager,
COALESCE(AUD.DURATION || ' ' || AUD.DURATION_UNIT, '') AS duration,
ATM.AUDIT_TYPE,AP.STATUS AS audit_status, ACC.ACC_CODE ,ACC.ACC_NAME,
ACC.ADDRESS || ', '|| ACC.CITY || ', '|| ST.NAME || ', ' || COU.NAME || ', '|| ACC.POSTAL_CODE AS facility_address,
AUD.AUDIT_NO || '-' || AUD.VISIT_NO audit_visit,
AP.TEMPLATE_SEQ template_ver,
AUD.PERIOD_NO per_number,
AUD.AUDIT_YEAR aud_per_year,
AP.ATTEMPTED isAttempted
FROM VISITS VIS
LEFT JOIN AUDITS AUD ON AUD.VISIT_NO=VIS.visit_no
LEFT JOIN EMPLOYEES EMP ON EMP.SEQ=VIS.AUDITOR
LEFT JOIN ACCOUNTS ACC ON ACC.SEQ=AUD.FACILITY_SEQ
LEFT JOIN AUDIT_PERFORM AP ON AP.AUDIT_NO=AUD.AUDIT_NO
LEFT JOIN AUDIT_TYPE_MASTER ATM ON ATM.SEQ=AUD.AUDIT_TYPE_SEQ
LEFT JOIN EMPLOYEES MGR ON MGR.SEQ=EMP.MGR_EMP_SEQ
LEFT JOIN COUNTRIES COU ON COU.COU_CODE=ACC.COU_CODE
LEFT JOIN STATES ST ON ST.CODE=ACC.STATE_CODE
WHERE VIS.VISIT_NO=? AND AUD.AUDIT_NO=?`,
        params: [visitNo, auditNo]
    };
}

/**
 * Get Sections of an Audit with un answered questions count
 * @param auditNo Audit no
 */
export function getSectionsUnAnsCount(auditNo: string): SqLiteQueryWithParams;
export function getSectionsUnAnsCount(auditNo: string, sectionSeq: string): SqLiteQueryWithParams;
export function getSectionsUnAnsCount(auditNo: string, sectionSeq?: string): SqLiteQueryWithParams {
    let query =  `SELECT SEC.SEQ AS section_seq,SEC.can_be_repeated as canBeRepeated, SEC.can_be_edited as canBeEdited, SEC.template_seq, 
    CASE WHEN SEC.can_be_repeated='1' THEN AUDSEC.SECTION_NAME ELSE COALESCE (tra.section_name, AUDSEC.SECTION_NAME)  end AS section_name, 1 'visible',AUDSEC.seq, AUDSEC.na_flg, SEC.can_be_edited,sec.na_allowed,sec.can_be_repeated
    ,SEC.section_id
    ,(select count(distinct AUDQUES.seq ) from section_question sq,AUDIT_QUESTIONS AUDQUES
    where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO ) Total
    ,(select count(distinct AUDQUES.seq ) from section_question sq,AUDIT_QUESTIONS AUDQUES
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO and (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)='') ) un_answered_ques_count
    ,(select count(distinct AUDQUES.seq ) from section_question sq,AUDIT_QUESTIONS AUDQUES
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO and (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is not null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)!='') ) ans
    ,( case when AUDSEC.na_flg='1' then '#046dab'
    when exists (select 1 from section_question sq,AUDIT_QUESTIONS AUDQUES
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO and (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)='')) then '#A9A9A9'
    when exists (select 1 from section_question sq,AUDIT_QUESTIONS AUDQUES where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO
    and AUDQUES.critical_flg='1') then '#a30a32'
    when exists (select 1 from section_question sq,AUDIT_QUESTIONS AUDQUES where sq.question_seq=AUDQUES.question_seq and sq.section_seq=sec.seq and AUDQUES.AUDIT_NO=AUDSEC.AUDIT_NO
    and AUDQUES.ca_flg='1') then '#f57f2b' 
    Else '#60a643' end) col
    FROM AUDIT_SECTIONS AUDSEC
    INNER JOIN SECTIONS SEC ON SEC.SEQ=AUDSEC.SECTION_SEQ and sec.section_type='SECTION'
    LEFT JOIN sections_vw tra ON SEC.seq = tra.seq AND tra.locale = 'en'
    where AUDSEC.AUDIT_NO=?`;
    let params = [auditNo];
    if(sectionSeq){
        query = query + ` AND AUDSEC.seq = ?`;
        params.push(sectionSeq);
    }
    query = query + ` ORDER BY sec.display_seq ASC`;
    return {query, params};
}

/**
 * Get all questions by section sequence
 * @param auditNo Audit#
 * @param secSeq Section sequence
 */
export function getQuesBySecSeq(auditNo: string, secSeq: string): SqLiteQueryWithParams;
/**
 * Get a question by section sequence and audit question sequence
 * @param auditNo Audit#
 * @param secSeq section seq no
 * @param audit_ques_seq audit question sequence
 */
export function getQuesBySecSeq(auditNo: string, secSeq: string, audit_ques_seq: string): SqLiteQueryWithParams;
export function getQuesBySecSeq(auditNo: string, secSeq: string, audit_ques_seq?: string): SqLiteQueryWithParams {

    let query = `select  1 'visible', AUDSEC.AUDIT_NO, QUES.SEQ as ques_seq, AUDSEC.SEQ AS audit_sec_seq, AUDSEC.SECTION_SEQ, AUDSEC.SECTION_NAME, AUDQUES.SEQ AS audit_ques_seq,
    QUES.QUESTION_ID, QUES.question , QUES.template_seq, AUDQUES.ca_flg, AUDQUES.critical_flg, AUDQUES.na,
	 CASE WHEN QUES.ANSWER_TYPE IN ('CHECKBOX','RADIO') THEN
    (SELECT string_agg( cast(AQANS.ANSWER_SEQ as text) ,',')  FROM audit_ques_answer AQANS WHERE AQANS.audit_ques_seq = AUDQUES.seq AND COALESCE(AQANS.sync_action, '')!='DELETE'
    )
    ELSE AUDQUES.ANSWER END AS ques_answer,QUES.ANSWER_TYPE,AUDQUES.notes,
	(select count (1) from audit_pre_defined_notes apdn WHERE apdn.audit_ques_seq = AUDQUES.seq AND COALESCE( apdn.sync_action, '')!='DELETE') as pdn_count,
	 (select STRING_AGG( cast(tq.answer_seq as text), ',') FROM trigger_questions tq where tq.parent_ques_seq=AUDQUES.QUESTION_SEQ) trigger_ans_seq,
	 (SELECT count (1) from attachments WHERE object_type = 'audit_questions' AND object_ref = AUDQUES.SEQ AND COALESCE( sync_action, '')!='DELETE') as att_count
	  ,(select count(1) from policies where object_name='questions' and object_seq=AUDQUES.QUESTION_SEQ) POLICY_COUNT
    ,(select count(1) from pre_defined_notes pdn where pdn.question_seq=AUDQUES.QUESTION_SEQ) PREDEF_COUNT, ques.notes_type NOTES_DATA_TYPE
	from audit_sections AUDSEC 
	inner join audit_questions AUDQUES on AUDQUES.audit_section_seq=AUDSEC.seq  and AUDSEC.audit_no=AUDQUES.audit_no
	inner join section_question sq ON sq.question_seq=AUDQUES.question_seq 
	INNER JOIN QUESTIONS QUES ON QUES.SEQ=AUDQUES.QUESTION_SEQ
	INNER JOIN SECTIONS SEC ON AUDSEC.Section_seq=SEC.SEQ and sec.section_type='SECTION' 
	where AUDQUES.AUDIT_NO= ? and AUDSEC.seq=?`;
    let params = [auditNo, secSeq];
    if(audit_ques_seq){
        query+= 'AND AUDQUES.seq = ?';
        params.push(audit_ques_seq);
    }
    query+= ` ORDER BY QUES.DISPLAY_SEQ ASC`;
    return {query, params};
}

export function triggerQuestionByParentQues(auditNo: string, auditQuesSeq: string):SqLiteQueryWithParams {
    return {query :`SELECT  DISTINCT 1 'visible',AUDQUESCHILd.PARENT_QUES_SEQ as parentQuesSeq, AUDQUESCHILd.seq as audit_ques_seq,AUDSEC.AUDIT_NO, QUES.SEQ as ques_seq, AUDSEC.SEQ AS audit_sec_seq, AUDSEC.SECTION_SEQ, AUDSEC.SECTION_NAME, 
	QUES.QUESTION_ID, QUES.question , QUES.template_seq,
	QUES.ANSWER_TYPE, p.policy_id, p.policy_name, p.policy_text,
	CASE WHEN QUES.ANSWER_TYPE IN ('CHECKBOX','RADIO') THEN
(SELECT string_agg(ANSWER_SEQ ,',')  FROM audit_ques_answer AQANS WHERE AQANS.audit_ques_seq = AUDQUESCHILd.seq AND COALESCE(AQANS.sync_action, '')!='DELETE')
ELSE AUDQUESCHILd.ANSWER END AS ques_answer,
(SELECT count (1) from attachments WHERE object_type = 'audit_questions' AND object_ref = AUDQUESCHILd.seq) as att_count
FROM AUDIT_SECTIONS AUDSEC
LEFT JOIN AUDIT_QUESTIONS AUDQUES ON AUDQUES.AUDIT_SECTION_SEQ=AUDSEC.SEQ
left join trigger_questions tq on tq.parent_ques_seq=AUDQUES.QUESTION_SEQ
LEFT JOIN AUDIT_QUESTIONS AUDQUESCHILd ON AUDQUESCHILd.QUESTION_SEQ=tq.child_ques_seq
LEFT JOIN QUESTIONS QUES ON QUES.SEQ=tq.child_ques_seq
LEFT JOIN policies p ON UPPER(p.OBJECT_NAME)='QUESTIONS' AND p.OBJECT_SEQ=QUES.SEQ
WHERE AUDSEC.AUDIT_NO=? 
AND  AUDQUES.SEQ =? AND AUDQUESCHILd.PARENT_QUES_SEQ IS NOT NULL
AND COALESCE(AUDQUES.sync_action, '')!='DELETE'
ORDER BY AUDSEC.SECTION_SEQ, QUES.DISPLAY_SEQ ASC`,
params : [auditNo, auditQuesSeq]
};
}

export function getAnswers(questionSeqs: number[], secSeq: number, templateSeq: number):SqLiteQueryWithParams {
    const quesSeqList = questionSeqs.join(',');
    return {
        query: `SELECT SEC.TEMPLATE_SEQ,SQ.QUESTION_SEQ,QUES.ANSWER_TYPE, AO.ANSWER, AO.SEQ as ans_seq FROM SECTIONS SEC
INNER JOIN SECTION_QUESTION SQ ON SQ.SECTION_SEQ=SEC.SEQ
INNER JOIN QUESTIONS QUES ON QUES.SEQ=SQ.QUESTION_SEQ
LEFT JOIN ANSWER_OPTIONS AO ON AO.QUESTION_SEQ=SQ.QUESTION_SEQ
WHERE SEC.TEMPLATE_SEQ=? and sec.seq=?  AND QUES.SEQ in (?)
ORDER BY ques.DISPLAY_SEQ ASC`, params : [templateSeq, secSeq, quesSeqList]
};
}

export function INSERT_SIGNATURE(signatureDetail: SignatureInfo, visit_number: string, sync_action: string, modifyUser: string, modify_date: Date): SqLiteQueryWithParams {
    return {
        query : `INSERT INTO attachments (seq, attachment_type, attachment_name, description, object_type, object_ref, attachment_path, device_attachment_path,
    doc_sensitivity, download_url, download_url_expiry_date, upload_url, upload_url_expiry_date, cloud_upload_status, active_flag, create_date, create_user,
    modify_date, modify_user, sync_action, sync_status) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)`,
    params : [signatureDetail.seq, 'signature', signatureDetail.attachment_name, 'signature', 'visits', visit_number, null, signatureDetail.attachment_path, 'doc_sensitivity', null, null, null, null, AttachmentCloudUploadStatus.NewlyInserted, 1, modify_date.toISOString(), modifyUser, modify_date.toISOString(), modifyUser, sync_action, PerformSyncState.Changed]
    };
}

export function insertAttachmentQuery(insertOptions: Attachment[]): SqLiteQueryWithParams {
    let query = `INSERT INTO attachments (seq, attachment_type, attachment_name, description, object_type, object_ref, attachment_path, device_attachment_path, doc_sensitivity, download_url, download_url_expiry_date, upload_url, upload_url_expiry_date, cloud_upload_status, active_flag, create_date, create_user,modify_date, modify_user, sync_action, sync_status ) VALUES`;
    const params: any[] = [];
    insertOptions.forEach((item: Attachment, index: number) => {
        let paramArray = [
            item.seq, item.attachment_type, item.attachment_name, item.description, item.object_type, item.object_ref, item.attachment_path,
            item.device_attachment_path, item.doc_sensitivity, item.download_url, item.download_url_expiry_date, item.upload_url,
            item.upload_url_expiry_date, item.cloud_upload_status, item.active_flag ? 1 : 0, item.create_date.toISOString(),
            item.create_user, item.modify_date ? item.modify_date.toISOString() : null, item.modify_user ? item.modify_user : null,
            item.sync_action, PerformSyncState.Changed]
        params.push(...paramArray);
        let paramPlaceholders = paramArray.map(() => '?').join(',');
        query += `(${paramPlaceholders})`;
        if (index < insertOptions.length - 1) {
            query += ',';
        }
    });
    return { query, params };
}

export function getQuestionAttachments(questionSeq: string) : SqLiteQueryWithParams {
    return {
        query: `SELECT * FROM  attachments WHERE object_ref = ?`,
        params: [questionSeq]
    };
}

export function getAttemptedAttachments(auditNo: string): SqLiteQueryWithParams {
    return {
        query: `SELECT * FROM  attachments WHERE object_ref = ? and attachment_type = ?`,
        params: [auditNo, AttachmentObjType.AuditAttempted]
    };
}

export function getPolicyData(audit_ques_seq: string): SqLiteQueryWithParams {
    return {
        query: `select p.seq policy_seq, p.policy_id, p.policy_name, p.policy_text
        from audit_questions aq
        inner join policies p on aq.question_seq=p.object_seq and p.object_name='questions'
        LEFT OUTER JOIN policies_vw tra on p.seq = tra.seq AND tra.locale = ?
        where aq.seq=?
        order by p.display_seq`,
        params: ['en', audit_ques_seq]
    };
}

/**
 * Get all the possible pre-defined notes for a question
 * @param ques_seq question sequence
 */
export function getQuesPossiblePDnotes(ques_seq: number): SqLiteQueryWithParams {
    return {
        query: `select * from pre_defined_notes where question_seq = ?`,
        params: [ques_seq]
    };
}

/**
 * Get all the selected pre-defined notes for a question
 * @param audit_ques_seq is audit question sequence
 */
export function getQuesSelectedPDnotes(audit_ques_seq: string): SqLiteQueryWithParams {
    return {
        query: `select * from audit_pre_defined_notes where audit_ques_seq = ? and COALESCE(sync_action, '')!=?`,
        params: [audit_ques_seq, 'DELETE']
    };
}

export function insertPDNQuery(_param: SelectedPDNotes) : SqLiteQueryWithParams{
    return {
        query: `insert into audit_pre_defined_notes (seq, audit_ques_seq, pdn_seq, additional_notes, create_date, create_user, sync_action, sync_status) VALUES 
        (?, ?, ?, ?, ?, ?, ?, ?)`,
        params: [
            _param.seq,
            _param.audit_ques_seq,
            _param.pdn_seq,
            _param.additional_notes,
            _param.create_date.toISOString(),
            _param.create_user,
            _param.sync_action,
            PerformSyncState.Changed
        ]
    };
}

export function updatePDNQuery(additional_notes: string, modify_date: Date, modify_user: string, pdn_seq: string, sync_action: string):SqLiteQueryWithParams {
    return {
        query: `update audit_pre_defined_notes SET additional_notes = ?, modify_date = ?, 
        modify_user = ?, sync_action = ?, sync_status = ? where pdn_seq = ?`,
        params: [
            additional_notes,
            modify_date.toISOString(),
            modify_user,
            sync_action,
            PerformSyncState.Changed,
            pdn_seq
        ]
    };
}

export function deletePDNQuery(pdn_seq: string, sync_action: string) :SqLiteQueryWithParams{
    return {
        query: `DELETE FROM audit_pre_defined_notes WHERE pdn_seq = ? `,
        params: [pdn_seq]
    };
}
export function deleteAttachmentQuery(attachmentSeq: string):SqLiteQueryWithParams {
    return {
        query: `DELETE FROM attachments WHERE seq = ?`,
        params: [attachmentSeq]
    };
}

export function attachmentNotUploaded(visitNo: string, auditNo?: string): SqLiteQueryWithParams {
    let query = `select ? visitNo,  att.seq, att.attachment_name as fileName, att.object_ref as auditQuestionSeq, AQ.audit_no as auditNo 
    from attachments att JOIN audit_questions AQ ON AQ.seq = att.object_ref 
    WHERE att.cloud_upload_status IN (?,?,?)
    UNION 
    select ? visitNo,  att.seq, att.attachment_name as fileName, att.object_ref as auditQuestionSeq, AU.audit_no as auditNo 
    from attachments att 
    LEFT JOIN audits as AU ON AU.visit_no = ?
    WHERE att.cloud_upload_status IN (?,?,? ) AND att.object_type in (?,?)`;
    let params: any[] = [visitNo, AttachmentCloudUploadStatus.NewlyInserted, AttachmentCloudUploadStatus.UploadUrlCreated, AttachmentCloudUploadStatus.Failed, visitNo, visitNo,
        AttachmentCloudUploadStatus.NewlyInserted, AttachmentCloudUploadStatus.UploadUrlCreated, AttachmentCloudUploadStatus.Failed, 'audits', 'visits'
    ];

    if (auditNo != undefined || auditNo != null) {
        query = query + ` UNION 
    select ? visitNo,  att.seq, att.attachment_name as fileName, att.object_ref as auditQuestionSeq, AU.audit_no as auditNo 
    from attachments att 
    LEFT JOIN audits as AU ON att.object_ref = ? AND att.attachment_type = ?
    WHERE att.cloud_upload_status IN (?,?,? ) AND att.object_type in (?,?)`
        params.push(visitNo, auditNo, 'audit_attempted', AttachmentCloudUploadStatus.NewlyInserted, AttachmentCloudUploadStatus.UploadUrlCreated, AttachmentCloudUploadStatus.Failed, 'audits', 'visits');

    }
    return {
        query,
        params
    };

}

export function attUploadURLUpdate(attData: AttUploadUrlResponse, modifyUser: string) : SqLiteQueryWithParams {
    const uploadExpiryDate = parseDateString(attData.uploadUrlLifeTime);
    return {
        query: `UPDATE attachments SET upload_url = ?, cloud_upload_status = ?, attachment_path = ?, upload_url_expiry_date = ?, modify_date = ?, modify_user = ? WHERE seq = ?`,
        params: [
            attData.uploadUrl,
            AttachmentCloudUploadStatus.UploadUrlCreated,
            attData.attachmentPath,
            uploadExpiryDate.toISOString(),
            new Date().toISOString(),
            modifyUser,
            attData.seq
        ]
    };
}

export function updateAttStatus(seq: string, modifyUser: string, status: AttachmentCloudUploadStatus, attachmentPath?: string) : SqLiteQueryWithParams {
    let query  = `UPDATE attachments SET cloud_upload_status = ?,modify_date = ?, modify_user = ?`;
    let params : any[] = [status, new Date().toISOString(), modifyUser];
    if(attachmentPath){
        query += `,attachment_path = ?`;
        params.push(attachmentPath);
    }
    query+= ` WHERE seq = ?`;
    params.push(seq);
    return {query, params};

}

export function getNotesQuery(audit_ques_seq: string) : SqLiteQueryWithParams {
    return {
        query: `select aq.notes, QUES.notes_type  from AUDIT_QUESTIONS aq 
        LEFT JOIN QUESTIONS QUES ON QUES.SEQ = aq.QUESTION_SEQ
        where aq.seq = ? and COALESCE(sync_action, '')!=?`,
        params: [audit_ques_seq, SyncAction.Delete]
    };
}

export function getNAAllowedSection(audit_number: string):SqLiteQueryWithParams {
    let query = `SELECT section_seq,section_name,audit_sec_na_flg FROM (
        SELECT  distinct SEC.SEQ AS section_seq,SEC.section_name,SEC.DISPLAY_SEQ,AUDSEC.NA_FLG AS audit_sec_na_flg
        FROM AUDIT_SECTIONS AUDSEC
        LEFT JOIN SECTIONS SEC ON SEC.SEQ=AUDSEC.SECTION_SEQ
        LEFT JOIN AUDIT_QUESTIONS AUDQUES ON AUDQUES.AUDIT_SECTION_SEQ=AUDSEC.SEQ
        WHERE AUDSEC.AUDIT_NO=? and sec.na_allowed=?)
        ORDER BY DISPLAY_SEQ ASC`;
    return {
        query,
        params: [audit_number, 1]
    };
}

export function updateSectionNAFlag(flgValue: number, modify_date: Date, modify_user: string, section_seq: number[], sync_action: string):SqLiteQueryWithParams {
    const seqString = section_seq.join(',');
    return {
        query: `update audit_sections set na_flg = ?, sync_action = ?, sync_status = ?, modify_date = ?, modify_user = ? WHERE section_seq in (?)`,
        params: [flgValue, sync_action, PerformSyncState.Changed, modify_date.toISOString(), modify_user, seqString]
    };
}

export function updateNarrativeAns(answer: string, auditQuesSec: string) : SqLiteQueryWithParams{
    return {
        query: `UPDATE audit_questions set answer = ?, sync_action = ?, sync_status = ? where seq = ?`,
        params: [answer, SyncAction.Update, PerformSyncState.Changed, auditQuesSec]
    };
}

export function deleteNarrativeQuesAns(auditQuesSec: string[]) : SqLiteQueryWithParams {
    const seqStr = auditQuesSec.map((seq) => `'${seq}'`).join(',');
    return {
        query: `UPDATE audit_questions set answer = ?, sync_action = ?, sync_status = ? WHERE seq IN (?)`,
        params: ['NULL',SyncAction.Update, PerformSyncState.Changed, seqStr]
    };
}

/**
 *
 * @param generatedSeq `audit_ques_seq` + `ans_ques`
 * @returns
 */
export function deleteNonNarrativeAns(generatedSeq: string[]): SqLiteQueryWithParams {
    const seqStr = generatedSeq.map((seq) => `'${seq}'`).join(',');
    return {
        query: `DELETE FROM audit_ques_answer WHERE seq IN  (?) `,
        params: [seqStr]
    };
}

export function CHECK_ANSWER(ans_seq: number, audit_ques_seq: string):SqLiteQueryWithParams {
    return {
        query: `SELECT oatsqd.non_compliant CA_APPLICABLE_FLG, oatsqd.critical_ans CRITICAL_ANS_FLG,
        oatsqd.not_applicable EXCL_QUES_FRM_CALC_FLG, oatsqd.severity
        FROM answer_options oatsqd
        WHERE oatsqd.seq = ? AND
        oatsqd.question_seq = (SELECT question_seq FROM audit_questions WHERE SEQ = ?)`,
        params: [ans_seq, audit_ques_seq]
    };
}

export function UPDATE_ANSWER(quesItem: QuestionItem): SqLiteQueryWithParams {
    let query = `UPDATE audit_questions SET notes = ? , ca_flg = ?, critical_flg = ?, na = ?, modify_date = ?, sync_action = ? WHERE seq = ?`;
    let params = [quesItem.notes ?quesItem.notes : null, quesItem.ca_flg, quesItem.critical_flg, quesItem.na, new Date().toISOString(), SyncAction.Update, quesItem.audit_ques_seq];
    return {query, params};
    
}

export function insertNonNarrativeAnswer(answers: { seq: string; ansSeq: number }[], auditQuesSeq: string, activeUser: string, currentDate: Date):SqLiteQueryWithParams {
    let query = `INSERT into audit_ques_answer (seq, audit_ques_seq, answer_seq, create_date, create_user, modify_date, modify_user, sync_action, sync_status) VALUES `;
    let params: any[] = [];
    answers.forEach((ans, index) => {
        query += `(?, ?, ?, ?, ?, ?, ?, ?, ?)`;
        params.push(ans.seq, auditQuesSeq, ans.ansSeq, currentDate.toISOString(), activeUser, currentDate.toISOString(), activeUser, SyncAction.Insert, PerformSyncState.Changed);

        if (index < answers.length - 1) {
            query += ',';
        }
    });
    return {query, params};
}


export function updateQuesNotes(note: string | Date | number, modify_date: Date, modify_user: string, audit_ques_seq: string, sync_action: string): SqLiteQueryWithParams {
    return {
        query: `UPDATE audit_questions SET notes = ?, sync_action = ?, sync_status = ?, modify_date = ?, modify_user = ? WHERE seq = ?`,
        params: [note, sync_action, PerformSyncState.Changed, modify_date.toISOString(), modify_user, audit_ques_seq]
    };
}

export function FETCH_SUBMIT_DETAILS(visit_number: string) : SqLiteQueryWithParams {
    const query = `SELECT p.actual_start_date, p.actual_end_date, p.STATUS, p.FAC_AUDIT_CONTACT_NAME, p.audit_note, oa.FACILITY_SEQ,  oa.AUDIT_NO,  
    (SELECT COUNT(1) as ATTACHMENTS FROM attachments at WHERE oa.visit_no = at.OBJECT_REF AND at.OBJECT_TYPE = ? AND 
    ATTACHMENT_TYPE = ? ) ATTACHMENT_CNT, OA.DURATION, OA.DURATION_UNIT 
    FROM audits oa, audit_perform p, visits oav WHERE oav.visit_no = ? and p.audit_no=oa.audit_no and oa.visit_no=oav.visit_no`;
    const params: any[] = ['visits', AttachmentType.Signature, visit_number];
    return {query, params};
}

export function GET_AUDIT_LIST(visit_number: string) :SqLiteQueryWithParams {
    const query =  `SELECT oa.AUDIT_NO FROM audits oa WHERE oa.VISIT_NO = ?`;
    const params  = [visit_number];
    return {query, params};
}

export function UPDATE_AUDIT_CONTACT(constctName: string, auditNote: string, visit_number: string, sync_action: string, modifyUser: string, modify_date: Date): SqLiteQueryWithParams {
    const query = `UPDATE audit_perform SET fac_audit_contact_name = ?, audit_note=?, modify_user = ?, modify_date = ?, 
    sync_action = ?,sync_status = ? WHERE audit_no IN (SELECT AUDIT_NO FROM audits WHERE visit_no = ?)`;
    return {query, params: [constctName, auditNote, modifyUser, modify_date.toISOString(), sync_action, PerformSyncState.Changed, visit_number]};
}

export function UPDATE_ACTUAL_TIME(
    startDateTime: Date,
    endDateTime: Date,
    visit_number: string,
    sync_action: string,
    modifyUser: string,
    modify_date: Date
) : SqLiteQueryWithParams {
    const query =  `UPDATE visits SET schedule_start = ?, schedule_end = ?, 
    modify_user = ?, modify_date = ?, sync_action = ?, sync_status = ? WHERE VISIT_NO = ?`;
    return {query, params: [startDateTime.toISOString(), endDateTime.toISOString(), modifyUser, modify_date.toISOString(), sync_action, PerformSyncState.Changed, visit_number]};

}

export function UPDATE_SET_PERFORM(
    startDateTime: Date,
    endDateTime: Date,
    visit_number: string,
    sync_action: string,
    modifyUser: string,
    modify_date: Date
): SqLiteQueryWithParams {
    // attempted = true need to discuss
    const query = `UPDATE audit_perform SET  actual_start_date = ?, actual_end_date = ?, MODIFY_DATE = ?, 
    MODIFY_USER = ?, sync_action = ?, sync_status = ? WHERE audit_no IN (SELECT oa.AUDIT_NO FROM audits oa WHERE oa.VISIT_NO = ?)`;
    return {query, params: [startDateTime.toISOString(), endDateTime.toISOString(), modify_date.toISOString(), modifyUser, sync_action, PerformSyncState.Changed, visit_number]};
}

export function UPDATE_SET_COMPLETED_FOR_SUBMIT(visit_number: string, sync_action: string, modifyUser: string, modify_date: Date): SqLiteQueryWithParams {
    const query = `UPDATE audit_perform SET status = 'SUBMITTED', form_completed = ?, modify_date = ?, modify_user = ?, sync_action = ?, sync_status = ? 
    WHERE AUDIT_NO IN (SELECT AUDIT_NO FROM audits WHERE visit_no = ?)`;
    return {query, params: [true, modify_date.toISOString(), modifyUser, sync_action, PerformSyncState.Changed, visit_number]};
}

export function INSERT_HISTORY_ON_SUBMIT(visit_number: string, sync_action: string, modifyUser: string, modify_date: Date): SqLiteQueryWithParams {
    const query = `INSERT INTO history_trails (object_type, object_ref, action, field_name, from_value, to_value, change_type, change_description, create_date, create_user, sync_action, sync_status) 
    VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`;
    return {query, params: ['audit_perform', visit_number, 'UPDATE', 'STATUS', 'CREATED', 'SUBMITTED', 'status change', 'status change', modify_date.toISOString(), modifyUser, sync_action, PerformSyncState.Changed]};
}

export function FETCH_EXISTING_SIGNATURE(visit_number: string): SqLiteQueryWithParams {
    const query = `select at.seq, at.ATTACHMENT_NAME, at.attachment_path from attachments at where attachment_type=? 
    and object_type=? and object_ref=?`;
    return {query, params: [AttachmentType.Signature, AttachmentObjType.Signature, visit_number]};
}

export function fetchSignature(object_ref: string):SqLiteQueryWithParams {
    return {
        query: `SELECT * FROM attachments WHERE object_type = ? AND object_ref = ? AND attachment_type = ?`,
        params: [AttachmentObjType.Signature, object_ref, AttachmentType.Signature]
    };
}

export function DELETE_EXISTING_SIGNATURE(seq: string) : SqLiteQueryWithParams{
    const query = `DELETE FROM attachments WHERE SEQ = ?`;
    return {query, params: [seq]};
}

export function FETCH_ACC_SEQ() {
    return `select seq from accounts`;
}

export function FETCH_GEOCODE(account_seq: string): SqLiteQueryWithParams {
    return {query: `select * from geocode where object_type=? and object_ref = ?`, params: [SqlObjType.Accounts, account_seq]};
}

export function INSERT_GEO_CODE(account_seq: string, lat: number, long: number, method: string, create_user: string, createDate: Date): SqLiteQueryWithParams {
    return {
        query: `INSERT INTO geocode (object_type, object_ref, longitude, latitude, method, create_user, create_date,modify_user, modify_date, sync_action, sync_status) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`, 
        params: [SqlObjType.Accounts, account_seq, long, lat, method, create_user, createDate.toISOString(), create_user, createDate.toISOString(), SyncAction.Insert, PerformSyncState.Changed]};
}


export function updateGeoCodeQuery(account_seq: string, lat: number, long: number, method: string, modify_user: string, syncAction: SyncAction): SqLiteQueryWithParams {
    const query = `UPDATE geocode SET longitude = ?, latitude = ?, method = ?, modify_user = ?, modify_date = ?, sync_action = ?, sync_status = ? 
    WHERE object_type = ? AND object_ref = ?`;
    const params : any[] = [long, lat, method, modify_user, new Date().toISOString(), syncAction, PerformSyncState.Changed, SqlObjType.Accounts, account_seq];
    return {query, params};
}

export function DELETE_GEO_CODE(account_seq: string): SqLiteQueryWithParams {
    return {
        query: `DELETE FROM geocode WHERE object_type = ? AND object_ref = ?`,
        params: [SqlObjType.Accounts, account_seq]
    };
}

export function getGeneralTabInfo(auditNo: string): SqLiteQueryWithParams {
    return{query : `select 'SECTION' DATA_TYPE, COALESCE (tra.section_name, aus.section_name) sectionName
    , COALESCE (tra.section_id, s.section_id) sec_dsp_id ,aus.SEC_FINAL_SCORE score, aus.sec_result grade, 'Y' show_flg
    ,(select count(1) from audit_questions ausq,  questions q, section_question sq
    where q.seq=sq.question_seq and ausq.question_seq=q.seq and sq.section_seq=s.seq and ausq.audit_no=aus.audit_no) total_questions
    ,(select count(1) from audit_questions ausq,  questions q, section_question sq
    where q.seq=sq.question_seq and ausq.question_seq=q.seq and sq.section_seq=s.seq and ausq.audit_no=aus.audit_no
    and (ausq.answer is not null
    or exists (select 1 from audit_ques_answer qa where qa.audit_ques_seq=ausq.seq )
    )
    ) answered_questions, aus.na_flg
    from audit_sections aus, sections s
    LEFT OUTER JOIN sections_vw tra ON s.seq = tra.seq AND tra.locale = 'en'
    where s.seq=aus.section_seq
    and s.section_type='SECTION'
    and aus.audit_no= ?
    order by s.display_seq, aus.seq`,
        params: [auditNo]
};
}

export function overallInformation(auditNo: string): SqLiteQueryWithParams {
    return { query : `select final_score/100.00 as final_score, ap.audit_result
    ,(select count(1) from audit_questions ausq,  questions q
    where  ausq.question_seq=q.seq and ausq.audit_no=ap.audit_no) total_questions
    ,(select count(1) from audit_questions ausq,  questions q
    where  ausq.question_seq=q.seq and ausq.audit_no=ap.audit_no
    and (ausq.answer is not null
    or exists (select 1 from audit_ques_answer qa where qa.audit_ques_seq=ausq.seq )
    )
    ) answered_questions, att.description
    from audit_perform ap, audit_templates att
    where ap.template_seq=att.seq and ap.audit_no=?`,
        params : [auditNo]
    };

}

export function getNonConformanceQuestionsList(auditNo: string): SqLiteQueryWithParams {

    return {
        query: `select COALESCE (tra1.section_id, s.section_id) SEC_DSP_ID, COALESCE (tra1.section_name, s.section_name) ADD_SECTION_NAME,
    COALESCE (tra1.template_seq, s.template_seq) template_seq, COALESCE (tra1.seq, s.seq) section_seq, 
    q.question_id QUES_DSP_ID,aq.NOTES NOTES,
    COALESCE (TRA.question, q.question) QUES_TEXT,aq.score,aq.seq AUSQ_SEQ,
    (case when aq.parent_ques_seq is null then null else aq.parent_ques_seq end) parent,(case when (aq.parent_ques_seq is null ) then 0 else 1 end) levelno,
    0 trigger_cnt,
    (select count(1) from audit_pre_defined_notes adnl where adnl.audit_ques_seq=aq.seq) PN_cnt,
    (select count(1) from attachments att where att.object_type='audit_questions' and att.object_ref=aq.seq) ATTACH_cnt,
    q.seq ques_seq, q.answer_type, aq.ca_flg
        ,(select aqp.seq from questions qp, trigger_questions tq, audit_questions aqp
        where qp.seq=tq.parent_ques_seq and aqp.question_seq=qp.seq and aqp.audit_no=aq.audit_no and tq.child_ques_seq=q.seq) parent_ques_seq,
    CASE WHEN q.ANSWER_TYPE IN ('CHECKBOX','RADIO') THEN
    (SELECT string_agg( COALESCE (tra2.ANSWER, AO.ANSWER) ,','  ORDER BY AO.DISPLAY_SEQ)  
    FROM audit_ques_answer AQANS
    inner join ANSWER_OPTIONS AO on AO.seq=AQANS.ANSWER_SEQ
    left join ANSWER_OPTIONS_vw tra2 on AO.seq = tra2.seq AND tra2.locale ='en'
    WHERE  AQANS.audit_ques_seq = aq.seq 
    ) ELSE aq.ANSWER END AS answer
    from audit_questions aq
    INNER JOIN section_question sq on aq.question_seq=sq.question_seq 
    INNER JOIN questions q on q.seq=aq.question_seq
    LEFT OUTER JOIN questions_vw tra on q.seq = tra.seq AND tra.locale ='en'
    INNER JOIN sections s on s.seq=sq.section_seq
    LEFT OUTER JOIN sections_vw tra1 on s.seq = tra1.seq AND tra1.locale ='en'
    where not exists (select 1  from trigger_questions tq where tq.child_ques_seq=q.seq)
    and s.section_type='SECTION' and aq.audit_no= ? and aq.ca_flg = true ORDER BY s.display_seq, q.display_seq`,
        params: [auditNo]
    };
}

export function fetchTriggerQuestions(questionSeq: number, auditNo: string): SqLiteQueryWithParams {

    return {
        query: `select COALESCE (tra1.section_id, s.section_id) SEC_DSP_ID,COALESCE (tra1.section_name, s.section_name) ADD_SECTION_NAME,
    q.question_id QUES_DSP_ID,aq.NOTES NOTES,
    COALESCE (TRA.question, q.question) QUES_TEXT,aq.score,aq.seq AUSQ_SEQ,
    (case when aq.parent_ques_seq is null then null else aq.parent_ques_seq end) parent,(case when (aq.parent_ques_seq is null ) then 0 else 1 end) levelno,
    0 trigger_cnt, (select count(1) from audit_pre_defined_notes adnl where adnl.audit_ques_seq=aq.seq) PN_cnt,
    (select count(1) from attachments att where att.object_type='audit_questions' and att.object_ref=aq.seq) ATTACH_cnt,
    q.seq ques_seq, q.answer_type, aq.ca_flg
        ,(select aqp.seq from questions qp, trigger_questions tq, audit_questions aqp
        where qp.seq=tq.parent_ques_seq and aqp.question_seq=qp.seq and aqp.audit_no=aq.audit_no and tq.child_ques_seq=q.seq) parent_ques_seq,
    CASE WHEN q.ANSWER_TYPE IN ('CHECKBOX','RADIO') THEN
    (SELECT string_agg( COALESCE (tra2.ANSWER, AO.ANSWER) ,','  ORDER BY AO.DISPLAY_SEQ)  
    FROM audit_ques_answer AQANS
    inner join ANSWER_OPTIONS AO on AO.seq=AQANS.ANSWER_SEQ
    left join ANSWER_OPTIONS_vw tra2 on AO.seq = tra2.seq AND tra2.locale ='en'
    WHERE  AQANS.audit_ques_seq = aq.seq)
    ELSE aq.ANSWER END AS answer
    from audit_questions aq
    INNER JOIN section_question sq on aq.question_seq=sq.question_seq 
    INNER JOIN questions q on q.seq=aq.question_seq
    LEFT OUTER JOIN questions_vw tra on q.seq = tra.seq AND tra.locale ='en'
    INNER JOIN sections s on s.seq=sq.section_seq
    LEFT OUTER JOIN sections_vw tra1 on s.seq = tra1.seq AND tra1.locale ='en'
    INNER JOIN trigger_questions tq on tq.child_ques_seq=q.seq
    where  s.section_type='SECTION'
    and aq.audit_no= ? and exist (select 1 from audit_questions par where par.seq=? and par.question_seq=tq.parent_ques_seq)
    and aq.ca_flg = true ORDER BY s.display_seq, q.display_seq`,
        params: [auditNo, questionSeq]
    };
}
export function fetchNCPredefinedNotes(AUSQ_SEQ: string, auditNo: string): SqLiteQueryWithParams {
    return {
        query: `select pdn.display_seq dsp_seq_nbr,pdn.note_id,pdn.note note_text,apdn.additional_notes addl_notes
        from audit_pre_defined_notes apdn, pre_defined_notes pdn, audit_questions aq
        where pdn.seq=apdn.pdn_seq and aq.seq=apdn.audit_ques_seq and aq.ca_flg = true and aq.audit_no = ? and aq.seq = ?
        order by pdn.display_seq,pdn.note_id`,
        params: [auditNo, AUSQ_SEQ]
    };
}

export function FETCH_NC_SUMMARY_ATTACHMENT(AUSQ_SEQ: string): SqLiteQueryWithParams {
    return {
        query: `select attachment_path attachment,seq ID, ATTACHMENT_NAME, attachment_type 
        from attachments att where att.object_type='audit_questions' and att.object_ref= ?`,
        params: [AUSQ_SEQ]
    };
}

export function fetchUnansweredQuestions(auditNo: string): SqLiteQueryWithParams {
    return {  query :  `SELECT QUES.template_seq, AUDSEC.section_seq section_seq, AUDSEC.SECTION_NAME AS Section, QUES.question_id,QUES.question , QUES.seq AS ques_seq 
    FROM AUDIT_SECTIONS AUDSEC
    INNER JOIN SECTIONS SEC ON SEC.SEQ=AUDSEC.SECTION_SEQ and SEC.SECTION_TYPE='SECTION'
    LEFT JOIN AUDIT_QUESTIONS AUDQUES ON AUDQUES.AUDIT_SECTION_SEQ=AUDSEC.SEQ
    LEFT JOIN QUESTIONS QUES ON QUES.SEQ=AUDQUES.QUESTION_SEQ
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    WHERE AUDSEC.AUDIT_NO= ? AND AUDSEC.na_flg='0' 
    AND (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)='')
    ORDER BY SEC.display_seq,QUES.display_seq  ASC`,
        params : [auditNo]
};
}


export function fetchFacilityReportSection(auditNo: string): SqLiteQueryWithParams {
    return { 
        query: `select  AUDSEC.AUDIT_NO, QUES.SEQ as ques_seq, AUDSEC.SEQ AS audit_sec_seq, AUDSEC.SECTION_SEQ, AUDSEC.SECTION_NAME AS sectionName, AUDQUES.SEQ AS audit_ques_seq,
QUES.question_id, QUES.question , QUES.template_seq, AUDQUES.ca_flg, AUDQUES.critical_flg, AUDQUES.na,
CASE WHEN QUES.ANSWER_TYPE IN ('CHECKBOX','RADIO') THEN
(SELECT string_agg( cast(AO.ANSWER as text) ,','  ORDER BY AO.DISPLAY_SEQ)  FROM audit_ques_answer AQANS, ANSWER_OPTIONS AO WHERE AO.seq=AQANS.ANSWER_SEQ and AQANS.audit_ques_seq = AUDQUES.seq AND COALESCE(AQANS.sync_action, '')!='DELETE'
)
ELSE AUDQUES.ANSWER END AS answer,QUES.ANSWER_TYPE,AUDQUES.notes,
 (select STRING_AGG(ATT.attachment_path,',' ORDER BY ATT.OBJECT_REF ASC ) 
    from attachments att where att.object_type='audit_questions' and att.object_ref=AUDQUES.seq) as attachment_path,
(select count (1) from audit_pre_defined_notes apdn WHERE apdn.audit_ques_seq = AUDQUES.seq AND COALESCE( apdn.sync_action, '')!='DELETE'
) as pdn_count,
(select STRING_AGG( cast(tq.answer_seq as text), ',') FROM trigger_questions tq where tq.parent_ques_seq=AUDQUES.QUESTION_SEQ) trigger_ans_seq,
(SELECT count (1) from attachments WHERE object_type = 'audit_questions' AND object_ref = AUDQUES.SEQ AND COALESCE( sync_action, '')!='DELETE'
) as att_count
,(select count(1) from policies where object_name='questions' and object_seq=AUDQUES.QUESTION_SEQ) POLICY_COUNT
,QUES.max_score, AUDQUES.score,AUDQUES.repeat_count   
from audit_questions AUDQUES
INNER JOIN section_question sq ON sq.question_seq=AUDQUES.question_seq
INNER JOIN AUDIT_SECTIONS AUDSEC ON SQ.section_seq=AUDSEC.section_seq and AUDSEC.audit_no=AUDQUES.audit_no
INNER JOIN SECTIONS SEC ON AUDSEC.Section_seq=SEC.SEQ and sec.section_type='SECTION' 
INNER JOIN QUESTIONS QUES ON QUES.SEQ=AUDQUES.QUESTION_SEQ
where AUDQUES.AUDIT_NO= ? 
ORDER BY sec.DISPLAY_SEQ, QUES.DISPLAY_SEQ ASC`,
params : [auditNo]
};
}


export function setSyncStatusInProgress(tableName: string, syncAction: SyncAction): SqLiteQueryWithParams {
    return {
        query: `UPDATE ${tableName} SET sync_status = ? WHERE sync_action = ? AND sync_status = ?`,
        params: [PerformSyncState.InProgress, syncAction, PerformSyncState.Changed]
    };
}

export function resetSyncStatusOnFailed(tableName: string, syncAction: SyncAction) : SqLiteQueryWithParams {
    return { query :`UPDATE ${tableName} SET sync_status = ? WHERE sync_action = ? AND sync_status = ?`
    , params: [PerformSyncState.Changed,syncAction, PerformSyncState.InProgress]};
}

export function dirtyRecords(tableName: string, syncAction: SyncAction): SqLiteQueryWithParams {
    return {
        query: `select * from ${tableName} where sync_action = ? AND sync_status = ?`,
        params: [ syncAction, PerformSyncState.InProgress]
    };
}

/**
 * Get audit details
 * @param visitNo
 * @param auditNo
 * @returns
 */
export function fetchAuditEvalQuery(visitNo: string, auditNo: string): SqLiteQueryWithParams {
    return {query :  `SELECT DISTINCT AUD.AUDIT_NO,
     ACC.ACC_NAME,
     ACC.ACC_CODE ,      
    ACC.ADDRESS || ', '|| ACC.CITY || ', '|| ST.NAME || ', ' || COU.NAME || ', '|| ACC.POSTAL_CODE AS facility_address,
    AUD.SPL_INSTRUCTIONS, 
    MGR.EMP_NAME AS account_manager,
    COALESCE(AUD.DURATION || ' ' || AUD.DURATION_UNIT, '') AS duration,
    ATM.AUDIT_TYPE,
    AP.STATUS AS audit_status
    FROM VISITS VIS
    LEFT JOIN AUDITS AUD ON AUD.VISIT_NO=VIS.visit_no
    LEFT JOIN EMPLOYEES EMP ON EMP.SEQ=VIS.AUDITOR
    LEFT JOIN ACCOUNTS ACC ON ACC.SEQ=AUD.FACILITY_SEQ
    LEFT JOIN AUDIT_PERFORM AP ON AP.AUDIT_NO=AUD.AUDIT_NO
    LEFT JOIN AUDIT_TYPE_MASTER ATM ON ATM.SEQ=AUD.AUDIT_TYPE_SEQ
    LEFT JOIN EMPLOYEES MGR ON MGR.SEQ=EMP.MGR_EMP_SEQ
    LEFT JOIN COUNTRIES COU ON COU.COU_CODE=ACC.COU_CODE
    LEFT JOIN STATES ST ON ST.CODE=ACC.STATE_CODE
    WHERE VIS.VISIT_NO=? AND AUD.AUDIT_NO=?`,
        params : [visitNo, auditNo]
    };
}

/**
 * Get audit details
 * @param visitNo
 * @param auditNo
 * @returns
 */
export function fetchAuditContactQuery(visitNo: string, auditNo: string): SqLiteQueryWithParams {
    return {
        query : `SELECT DISTINCT      
    EMP.EMP_NAME AS g_auditor,
     ATM.AUDIT_TYPE AS b_audit_type,
    AUD.CATEGORY AS d_audit_category, 
    AUD.AUDIT_NO || '/' || AUD.VISIT_NO a_audit_visit,
    AP.TEMPLATE_SEQ c_template_ver,
    AUD.PERIOD_NO f_aud_per_year_no,
    AUD.AUDIT_YEAR e_aud_per_year,
    AP.AUDIT_NOTE z_audit_note
    FROM VISITS VIS
    LEFT JOIN AUDITS AUD ON AUD.VISIT_NO=VIS.visit_no
    LEFT JOIN EMPLOYEES EMP ON EMP.SEQ=VIS.AUDITOR
    LEFT JOIN ACCOUNTS ACC ON ACC.SEQ=AUD.FACILITY_SEQ
    LEFT JOIN AUDIT_PERFORM AP ON AP.AUDIT_NO=AUD.AUDIT_NO
    LEFT JOIN AUDIT_TYPE_MASTER ATM ON ATM.SEQ=AUD.AUDIT_TYPE_SEQ
    LEFT JOIN EMPLOYEES MGR ON MGR.SEQ=EMP.MGR_EMP_SEQ
    LEFT JOIN COUNTRIES COU ON COU.COU_CODE=ACC.COU_CODE
    LEFT JOIN STATES ST ON ST.CODE=ACC.STATE_CODE
    WHERE VIS.VISIT_NO=? AND AUD.AUDIT_NO=?`,
        params : [visitNo, auditNo]
    };
}
export function resetSyncAction(tableName: string) : SqLiteQueryWithParams {
    return {
        query: `update ${tableName} set sync_action = NULL , sync_status = ? WHERE sync_status = ?`,
        params: [PerformSyncState.SyncCompleted, PerformSyncState.Changed]
    };
}

export function removeTriggerQuestions(parentQuesSeq: string): SqLiteQueryWithParams {
    return {
        query: `DELETE FROM audit_questions WHERE parent_ques_seq = ?`,
        params: [parentQuesSeq]
    };
}

export function getQuestionName(quesSeq: string): SqLiteQueryWithParams {
    return {
        query: `select question from questions where seq = ?`,
        params: [quesSeq]
    };
}

export function attDownSyncDto() : string {
    return `select seq, attachment_path as attachmentPath, attachment_name as attachmentName from attachments 
     where cloud_upload_status is NULL`;
}

export function updateDownSyncAtt(urls: AttDownloadUrlResDto[]) {
    let query = `UPDATE attachments `;
    let downUrl = `SET cloud_upload_status = '${AttachmentCloudUploadStatus.DownloadedUrlCreated}', download_url = CASE `;
    let downUrlExpDate = `download_url_expiry_date = CASE `;
    let whereClause = `WHERE seq IN (`
    urls.forEach((url: AttDownloadUrlResDto, index: number, urls: AttDownloadUrlResDto[]) => {
        downUrl += `WHEN seq = '${url.seq}' THEN '${url.downloadUrl}' `;
        const expireDate = parseDateString(url.downloadUrlLifeTime);
        downUrlExpDate += `WHEN seq = '${url.seq}' THEN '${expireDate.toISOString()}' `;
        whereClause += `'${url.seq}'`
        if (index === urls.length - 1) {
            downUrl += `END, `;
            downUrlExpDate += `END `;
            whereClause += ')';
        } else {
            whereClause += ','
        }
    });
    query += downUrl;
    query += downUrlExpDate;
    query += whereClause
    return query;
}

export function getAccountSeq(visit_no: string) : SqLiteQueryWithParams {
    return {
        query: `select facility_seq from audits where visit_no = ?`,
        params: [visit_no]
    };
}

export function fetchContact() {
    return `select * from contacts`;
}

export function deleteContact(email: string) : SqLiteQueryWithParams {
    return {
        query: `DELETE FROM contacts WHERE email = ?`,
        params: [email]
    };
}

export function updateContactSeq(email: string, seq: string) : SqLiteQueryWithParams {
    return {
        query: `UPDATE contacts SET seq = ? WHERE email = ?`,
        params: [seq, email]
    };
}

export function updateContactSqs(contacts: PerformContact[]): SqLiteQueryWithParams {
    let query = `UPDATE contacts SET seq = CASE `;
    let whereClause = `WHERE email IN (`;
    const params : any[] = [];
    contacts.forEach((contact: PerformContact, index: number, contacts: PerformContact[]) => {
        query += `WHEN email = ? THEN ? `;
        params.push(contact.email, contact.seq);
        whereClause += `?`;
        params.push(contact.email);
        if (index === (contacts.length - 1)) {
            query += `END `;
        } else {
            whereClause += ','
        }
    }
    );

    whereClause += ')';
    query += whereClause;
    return {query, params};

}

export function updateGeocodeSeq(seq: string): SqLiteQueryWithParams {
    return {
        query: `UPDATE geocode SET seq = ?`,
        params: [seq]
    };
}

export function getNullSeqContacts() {
    return `SELECT * FROM contacts WHERE seq IS NULL`;
}

export function insertContact(_contact: ContactDto) : SqLiteQueryWithParams {
    return {
        query : `INSERT INTO contacts(
	  seq, acc_seq, salutation, first_name, middle_name, last_name, email, alternate_email, phone, alternate_phone, same_as_customer, address, city, 
      is_primary, address_type, create_date, create_user, sync_action, sync_status, modify_date, modify_user)
	  VALUES (null , ?, ?, ?, ?, ?, 
    ?, ?, ?, ?, ?, ?, ?,
    ? , ?, ?, ?, 
    ?, ?, ?, ?)`,
        params: [
            _contact.acc_seq,
            _contact.salutation,
            _contact.first_name,
            _contact.middle_name,
            _contact.last_name,
            _contact.email,
            _contact.alternate_email,
            _contact.phone,
            _contact.alternate_phone,
            _contact.same_as_customer,
            _contact.address,
            _contact.city,
            _contact.is_primary,
            _contact.address_type,
            _contact.create_date ? _contact.create_date.toISOString() : null,
            _contact.create_user,
            _contact.sync_action,
            PerformSyncState.Changed,
            _contact.create_date ? _contact.create_date.toISOString() : null,
            _contact.create_user
        ]
    };
}

export function updateContact(_contact: ContactDto): SqLiteQueryWithParams {
    return {
        query: `UPDATE contacts SET salutation = ?, first_name = ?, middle_name = ?, 
  last_name = ?, email = ?, alternate_email = ?, phone = ?, 
  alternate_phone = ?, same_as_customer = ?, address = ?, city = ?, 
    modify_user = ?, modify_date = ?, 
    sync_action = ?, sync_status = ? where email = ?`,
        params: [
            _contact.salutation,
            _contact.first_name,
            _contact.middle_name,
            _contact.last_name,
            _contact.email,
            _contact.alternate_email,
            _contact.phone,
            _contact.alternate_phone,
            _contact.same_as_customer,
            _contact.address,
            _contact.city,
            _contact.modify_user,
            _contact.modify_date ? _contact.modify_date.toISOString() : null,
            _contact.sync_action,
            PerformSyncState.Changed,
            _contact.email
        ]
    };
}

export function updateAuditStatus(visitNo: string, status: VisitStatus, modifyUser: string, modifyDate: Date):SqLiteQueryWithParams {
    return {
        query: `UPDATE audit_perform SET status = ?,  modify_user = ?, modify_date = ?, sync_action = ?, sync_status = ?  WHERE audit_no in ( 
	SELECT au.audit_no FROM audit_perform AS ap, audits AS au WHERE ap.audit_no = au.audit_no AND au.visit_no = ? )`,
        params: [
            status,
            modifyUser,
            modifyDate.toISOString(),
            SyncAction.Update,
            PerformSyncState.Changed,
            visitNo
        ]
    };
}



export function FETCH_COMPLETED_FLG(audit_no: string): SqLiteQueryWithParams {
    return {
        query: `SELECT form_completed FROM audit_perform WHERE audit_no = ?`,
        params: [audit_no]
    };
}

export function CHECK_OA_AUDIT_SEC_QUESTIONS_UPDATE_NEW(audit_no: string): SqLiteQueryWithParams {
    return {query :` SELECT case when COUNT(1) = 0 then 'Y' ELSE 'N' END  SHOULD_BE_VALUE
    FROM AUDIT_SECTIONS AUDSEC
    INNER JOIN SECTIONS SEC ON SEC.SEQ=AUDSEC.SECTION_SEQ and SEC.SECTION_TYPE='SECTION'
    LEFT JOIN AUDIT_QUESTIONS AUDQUES ON AUDQUES.AUDIT_SECTION_SEQ=AUDSEC.SEQ
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    WHERE AUDSEC.na_flg!='1'
    AND (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)='')
    AND AUDSEC.AUDIT_NO= ? `,
        params : [audit_no]
};
}

export function UPDATE_AUDIT_COMP_STATUS_ON_NAV(modify_date: Date, modify_user: string, audit_no: string): SqLiteQueryWithParams {
    return {
        query: `update audit_perform set form_completed=( SELECT case when count(1)>0 then '0' else '1' end 
    FROM AUDIT_SECTIONS AUDSEC
    INNER JOIN SECTIONS SEC ON SEC.SEQ=AUDSEC.SECTION_SEQ and SEC.SECTION_TYPE='SECTION'
    LEFT JOIN AUDIT_QUESTIONS AUDQUES ON AUDQUES.AUDIT_SECTION_SEQ=AUDSEC.SEQ
    LEFT JOIN AUDIT_QUES_ANSWER AQA ON AUDQUES.seq=AQA.audit_ques_seq 
    WHERE AUDSEC.AUDIT_NO= audit_perform.audit_no and AUDSEC.na_flg!='1'
    AND (COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER) is null or COALESCE (AQA.audit_ques_seq, AUDQUES.ANSWER)='') )
    , modify_date = ?, modify_user = ?, sync_action = ?, sync_status = ? where audit_no  = ?`,
        params: [modify_date.toISOString(), modify_user, SyncAction.Update, PerformSyncState.Changed, audit_no]
    };
}



export function updateAttemptedFlag(auditNo: string, isAttempted: number, modifyDate: Date, reason: string): SqLiteQueryWithParams {
    let query = "";
    const params :any[] = [];
    if (isAttempted === 1) {
        query = `UPDATE AUDIT_PERFORM SET ATTEMPTED = ?, ATTEMPTED_REASON = ? , 
        FORM_COMPLETED = 'Y', AUDIT_RESULT = NULL, score = null, FINAL_SCORE = NULL,MAX_SCORE= NULL, MODIFY_DATE = ? WHERE AUDIT_NO = ?`;
        params.push(isAttempted, reason, modifyDate.toISOString(), auditNo);
    } else {
        query = `UPDATE AUDIT_PERFORM SET ATTEMPTED = 0 , ATTEMPTED_REASON =  ? , FORM_COMPLETED = 'N' , MODIFY_DATE = ? 
        WHERE AUDIT_NO = ? `;
        params.push(reason, modifyDate.toISOString(), auditNo)
    }
    return {query, params};
}


export function insertDeleteRecords(options: InsertDeleteRecordsOptions): SqLiteQueryWithParams {
    let query = `INSERT INTO sync_delete_temp(id_name,id_value,table_name,visit_no,audit_no,action,sync_status) VALUES `;
    const idValues = [];
    const params:any[] = [];
    if (Array.isArray(options.id_value)) {
        idValues.push(...options.id_value);
    }
    else {
        idValues.push(options.id_value);
    }

    idValues.forEach(idValue => {
        query += ` (?, ?, ?, ?, ?, ?, ?)`;
        params.push(options.id_name, idValue, options.table_name, options.visit_no, options.audit_no ?? null, options.action, options.sync_status);
    })
    return {query, params};
}

export function getDeletedRecordsQuery() {
    return `SELECT * FROM sync_delete_temp`;
}

export function clearDeletedRecordsQuery() {
    return `DELETE FROM sync_delete_temp`;
}

export function fetchAuditAttachments(audit_no: string) : SqLiteQueryWithParams {
    return {
        query: `SELECT * FROM  attachments WHERE object_ref = ? and attachment_type != ?`,
        params: [audit_no, 'audit_attempted']
    };
}

export function deleteAuditAttachments(attachmentSeq: string) : SqLiteQueryWithParams {
    return {
        query: `DELETE FROM attachments WHERE seq = ?`,
        params: [attachmentSeq]
    };
}


export function DownSyncAttPayloadQuery(visitNo: string, targetLocation: PerformAuditAttachmentLocation, auditNo?: string): SqLiteQueryWithParams {
    let query = `select ? as visitNo, seq,attachment_type as attachmentType,  attachment_path as attachmentPath, attachment_name as attachmentName `;
    const params : any[] = [visitNo];
    if(auditNo){
        query += `, ? as auditNo `;
        params.push(auditNo);
    }
    query += `from attachments WHERE `;
    if (auditNo) {
        if (targetLocation == PerformAuditAttachmentLocation.Questions) {
            query += `object_type = ? AND attachment_type = ? AND object_ref IN (select seq from audit_questions where audit_no=?)`;
            params.push(AttachmentObjType.Question, AttachmentType.Question, auditNo);
        } else if (targetLocation == PerformAuditAttachmentLocation.Attempted) {
            query += `object_type = ? AND attachment_type = ? AND object_ref = ?`;
            params.push(AttachmentObjType.Audit, AttachmentType.Attempted, auditNo);
        } else if (targetLocation == PerformAuditAttachmentLocation.Audit) {
            query += `object_type = ? AND attachment_type != ? AND object_ref = ?`;
            params.push(AttachmentObjType.Audit, AttachmentType.Attempted, auditNo);
        }
    } else {
        if (targetLocation == PerformAuditAttachmentLocation.SubmitFormSignature) {
            query += `object_type = ? AND attachment_type = ?`;
            params.push(AttachmentObjType.Signature, AttachmentType.Signature);
        }
    }
    return {query, params};
}



export function UpSyncAttQuery(visitNo: string, targetLocation: PerformAuditAttachmentLocation, auditNo?: string): SqLiteQueryWithParams {
    let query = `SELECT seq, attachment_name AS fileName, object_ref AS objectRef, object_type AS objectType, attachment_type AS attachmentType`;
    const params: any[] = [];
    if(auditNo){
        query += `, ? as auditNo`;
        params.push(auditNo);
    }
    if(visitNo){    
        query += `,? as visitNo`;
        params.push(visitNo);
    }
    query+=` FROM attachments `
    if (auditNo) {
        if (targetLocation == PerformAuditAttachmentLocation.Questions) {
            query += `WHERE object_type = ? AND attachment_type = ? `;
            params.push(AttachmentObjType.Question, AttachmentType.Question);
        } else if (targetLocation == PerformAuditAttachmentLocation.Attempted) {
            query += `WHERE object_type = ? AND attachment_type = ? `;
            params.push(AttachmentObjType.AuditAttempted, AttachmentType.Attempted)
        } else if (targetLocation == PerformAuditAttachmentLocation.Audit) {
            query += `WHERE object_type = ? AND attachment_type != ? `;
            params.push(AttachmentObjType.Audit, AttachmentType.Attempted);
        }
    } else {
        if (targetLocation == PerformAuditAttachmentLocation.SubmitFormSignature) {
            query += `WHERE object_type = ? AND attachment_type = ? `
            params.push(AttachmentObjType.Signature, AttachmentType.Signature);
        }

    }


    query += ` AND cloud_upload_status IN (?,?, ?)`;
    params.push(AttachmentCloudUploadStatus.NewlyInserted, AttachmentCloudUploadStatus.UploadUrlCreated, AttachmentCloudUploadStatus.Failed);
    return {query, params};  
}


export function sectionNameCount(sectionName: string, auditNo: string): SqLiteQueryWithParams {
    return {
        query: `SELECT COUNT() as count FROM audit_sections WHERE audit_no = ? and section_name = ?`,
        params: [auditNo, sectionName]
    };
}

export function updateSectionNameQuery(newSectionName: string, seq: string, auditNo: string, modify_user: string): SqLiteQueryWithParams {
    return {
        query: `UPDATE audit_sections  SET section_name = ?,  modify_date = ?, 
        modify_user = ?, sync_action = ?, sync_status = ? WHERE audit_sections.audit_no = ? AND seq = ?`,
        params: [newSectionName, new Date().toISOString(), modify_user, SyncAction.Update, PerformSyncState.Changed, auditNo, seq]
    };
}

export function getSectionRecords(auditSeq: string): SqLiteQueryWithParams {
    return {
        query: `SELECT audit_no, section_seq, na_flg, max_section_score, sec_deduction, catg_max_score, catg_deduction FROM audit_sections WHERE seq = ?`,
        params: [auditSeq]
    };
}


export function insertSecCopy(newSection: InsertCopySectionRecord, userName: string): SqLiteQueryWithParams {
    let insertDate = new Date().toISOString();
    let query = `INSERT INTO audit_sections (seq, audit_no, section_seq, section_name, na_flg, create_user, create_date, modify_user, modify_date, sync_action, sync_status) 
    VALUES (?, ?, ?, ?, 0, ?, ?, ?, ?, ?, ?)`;

    return {
        query,
        params: [
            newSection.seq,
            newSection.audit_no,
            newSection.section_seq,
            newSection.section_name,
            userName,
            insertDate,
            userName,
            insertDate,
            SyncAction.Insert,
            PerformSyncState.Changed
        ]
    };
}

export function getQuestionRecord(auditSecSeq: string): SqLiteQueryWithParams {
    return {
        query: `SELECT seq, audit_no, question_seq from audit_questions WHERE audit_section_seq = ? AND parent_ques_seq IS NULL`,
        params: [auditSecSeq]
    }
}


export function insertQuesCopy(questions: CopyQuesRecord[], audit_section_seq: string, userName: string): SqLiteQueryWithParams {
    let insertDate = new Date().toISOString();

    let query = `INSERT INTO audit_questions (seq, audit_no, question_seq, ca_flg, critical_flg, na, create_date, create_user, modify_date, modify_user, audit_section_seq, sync_action, sync_status) VALUES `
    const params: any[] = [];
    questions.forEach((ques, index) => {
        query += `(?, ?, ?, 0, 0, 0, ?, ?, ?, ?, ?, ?, ?)`;
        params.push(ques.seq, ques.audit_no, ques.question_seq, insertDate, userName, insertDate, userName, audit_section_seq, SyncAction.Insert, PerformSyncState.Changed);
        if (index < (questions.length - 1)) {
            query += ','
        }
    });
    return {query, params};
}

export function getExistingSecSeqs(oldSecSeq: string): SqLiteQueryWithParams {
    const [auditNo, secSeq, count] = oldSecSeq.split('-');
    return {
        query: `SELECT seq from audit_sections where seq like ? ORDER BY seq`,
        params: [`${auditNo}-${secSeq}-%`]
    }
}

export function getExistingQuesSeqs(oldQuesSeq: string): SqLiteQueryWithParams {
    const [auditNo, quesSeq, count] = oldQuesSeq.split('-');
    return {
        query: `SELECT seq from audit_questions where seq like ? ORDER BY seq`,
        params: [`${auditNo}-${quesSeq}-%`]
    }
}
